<template>
  <div>
    <form class="modal-dialog restore-password-dialog">
      <div class="modal-content b-shadow">
        <div class="modal-header">
          <h5 class="modal-title mx-auto">Przypomnienie hasła</h5>
        </div>
        <div class="modal-body">
          <div v-if="submitted" class="alert alert-success">
            Wysłano przypomnienie hasła na adres
            <i>{{form.email.value}}</i>.
          </div>
          <div class="mt-3" v-if="submitted">
            <router-link class="nav-link" :to="{ name: 'mainPage'}">&larr; Powrót do logowania</router-link>
          </div>
          <div v-if="!submitted" class="form-group">
            <label class="required">Email</label>
            <input
              id="email"
              name="email"
              class="form-control"
              type="email"
              required
              v-model="form.email.value"
              @blur="validateField($event, form.email)"
            />
            <span
              class="invalid-feedback"
              v-if="form.email.errors.required"
            >Email nie może być pusty</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="!submitted"
            class="btn btn-primary"
            :disabled="!submittable"
            @click="submit"
          >Wyślij</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Form from "../../form/src/Form";

export default {
  components: {},
  data() {
    return {
      form: Form.build({ email: "" }),
      submitted: false,
      progress: false
    };
  },
  computed: {
    submittable() {
      return !this.progress && !this.submitted;
    }
  },
  methods: {
    ...Form.methods(),
    async submit(evt) {
      let dataForm = this.validateForm(evt, this.form);
      if (dataForm) {
        try {
          this.progress = true;
          await this.$store.dispatch("user/restorePassword", dataForm);
          this.progress = false;
          this.submitted = true;
        } catch (e) {
          this.setCustomError(this.form.email);
          this.progress = false;
          this.submitted = false;
          console.log(e);
        }
      }
    }
  },
  async beforeMount() {
    let auth = await this.$store.dispatch("user/isAuthorized");
    if (auth) {
      this.$router.replace({ name: "searchPage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/src/RestorePasswordPage.vue